import React from 'react';
import { Filter } from 'lucide-react';
import { CountBadge } from './CountBadge';

/**
 * Standardised filter toggle button for the HR Portal.
 *
 * This is the ONLY way to render a filter toggle button.
 * Do NOT create inline filter buttons with manual className conditions.
 *
 * Three visual states:
 *   1. Panel closed, no active filters  →  grey default
 *   2. Panel closed, active filters     →  grey + CountBadge overlay
 *   3. Panel open                       →  full theme fill (red/blue)
 *
 * @param {'admin'|'employee'} [theme='admin']
 * @param {boolean}  isOpen        - Whether the filter panel is expanded
 * @param {number}   [activeCount=0] - Number of active filter criteria
 * @param {Function} onClick       - Toggle handler
 * @param {string}   [title='Filters']
 * @param {string}   [className]   - Extra classes (margins, etc.)
 */
const THEME_CONFIG = {
  admin: {
    base: 'icon-button-admin',
    active: 'bg-red-500 text-white hover:bg-red-600 hover:text-white',
  },
  employee: {
    base: 'icon-button',
    active: 'bg-blue-800 text-white hover:bg-blue-900 hover:text-white',
  },
};

export const FilterButton = ({
  theme = 'admin',
  isOpen = false,
  activeCount = 0,
  onClick,
  title = 'Filters',
  className = '',
}) => {
  const config = THEME_CONFIG[theme] || THEME_CONFIG.admin;
  const activeClasses = isOpen ? config.active : '';

  return (
    <button
      onClick={onClick}
      className={`${config.base} relative ${activeClasses} ${className}`.trim()}
      title={title}
      aria-label="Toggle filters"
    >
      <Filter className="w-4 h-4" />
      {!isOpen && activeCount > 0 && (
        <CountBadge count={activeCount} theme={theme} overlay />
      )}
    </button>
  );
};

export default FilterButton;
